import { getCurrentApi } from './api';
import { ZoneCategory, CreateZoneCategoryDto, UpdateZoneCategoryDto } from '../models/ZoneCategory';

// Get all zone categories for the current hotel
export const getZoneCategories = async (): Promise<ZoneCategory[]> => {
  try {
    const api = getCurrentApi();
    const response = await api.get('/zonecategories');
    return response.data;
  } catch (error) {
    console.error('Error fetching zone categories:', error);
    throw error;
  }
};

// Get a specific zone category by ID
export const getZoneCategory = async (id: number): Promise<ZoneCategory> => {
  try {
    const api = getCurrentApi();
    const response = await api.get(`/zonecategories/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching zone category ${id}:`, error);
    throw error;
  }
};

// Create a new zone category (Hotel Manager only)
export const createZoneCategory = async (categoryData: CreateZoneCategoryDto): Promise<ZoneCategory> => {
  try {
    console.log('Creating zone category with data:', categoryData);
    const api = getCurrentApi();
    const response = await api.post('/zonecategories', categoryData);
    console.log('Zone category created successfully:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error creating zone category:', error);
    throw error;
  }
};

// Update an existing zone category (Hotel Manager only)
export const updateZoneCategory = async (id: number, categoryData: UpdateZoneCategoryDto): Promise<ZoneCategory> => {
  try {
    console.log(`Updating zone category ${id} with data:`, categoryData);
    const api = getCurrentApi();
    const response = await api.put(`/zonecategories/${id}`, categoryData);
    console.log('Zone category updated successfully:', response.data);
    return response.data;
  } catch (error) {
    console.error(`Error updating zone category ${id}:`, error);
    throw error;
  }
};

// Delete a zone category (Hotel Manager only)
export const deleteZoneCategory = async (id: number): Promise<void> => {
  try {
    console.log(`Deleting zone category ${id}`);
    const api = getCurrentApi();
    await api.delete(`/zonecategories/${id}`);
    console.log('Zone category deleted successfully');
  } catch (error) {
    console.error(`Error deleting zone category ${id}:`, error);
    throw error;
  }
};

// Helper function to convert backend categories to filter format
export const convertCategoriesToFilters = (categories: ZoneCategory[], zones: any[]) => {
  return categories.map(category => {
    // Count zones that belong to this category
    const zoneCount = zones.filter(zone => zone.categoryId === category.id).length;
    
    return {
      id: category.id,
      name: category.name,
      icon: category.icon,
      color: category.color,
      description: category.description,
      zoneCount: zoneCount
    };
  });
};

// Get zone count for a specific category
export const getZoneCountForCategory = (categoryId: number | null, zones: any[]): number => {
  if (categoryId === null) {
    return zones.length; // All zones
  }
  return zones.filter(zone => zone.categoryId === categoryId).length;
};